module.exports = __webpack_public_path__ + "static/media/Shikanoin heizou.c20ab407.png";